import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiRoutes} from '../../../config/api-routes';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';

@Injectable()
export class AccountSiteService {

  private readonly redirectFragment = '&redirectUrl=' + window.location.href;
  private readonly applicationFragment = 'application=Building';
  private readonly loginPageFragment = 'login';
  private readonly signOutPageFragment = 'signout';
  private readonly dashboardPageFragment = 'dashboard';


  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService,
    private apiRouteConfig: ApiRoutes) {}

  public goToLoginPage(redirect: boolean) {
    let url = `${environment.accountSiteUrl}${this.loginPageFragment}?${this.applicationFragment}`;
    if (redirect) {
      url += this.redirectFragment;
    }
    window.location.href = url;
  }

  public goToSignOutPage() {
    window.location.href = `${environment.accountSiteUrl}${this.signOutPageFragment}?${this.applicationFragment}`;
  }

  public goToDashboardPage() {
    window.location.href = `${environment.accountSiteUrl}${this.dashboardPageFragment}`;
  }

  public getApplications(): Observable<any[]> {
    const options = {
      headers: {
        'jwt': this.tokenService.getToken(),
        'refreshtoken': this.tokenService.getRefreshToken(),
      }
    };
    return this.httpClient.get<any[]>(this.apiRouteConfig.APPLICATIONS_ROUTE, options);
  }
}
